"use strict";

define('uikit/views/table.add',['underscore', '../elements/button', './table.selected'], function (_, ButtonView, TableSelectedView) {
  var TableAddView = TableSelectedView.extend({
    internalViews: {
      view: ButtonView
    },
    internalViewOptions: {
      view: {
        circular: true,
        icon: 'plus',
        size: 'mini',
        className: ButtonView.prototype.className + ' invertable'
      }
    },
    initialize: function initialize() {
      TableSelectedView.prototype.initialize.apply(this, arguments);
      this.view.on('press', function () {
        var row = this.getRow();
        row.trigger('add', this);
      }, this);
    }
  });
  return TableAddView;
});

